import { EmsInstance } from "@/instance/axios";
import { createQueryKeys, mergeQueryKeys } from "@lukemorales/query-key-factory";
import {
  FemsApiFemsBillingGetRequest,
  FemsApiFemsDailyGetRequest,
  FemsApiFemsDailyLoadTypeGetRequest,
  FemsApiFemsDailyWithEquipmentTypeGetRequest,
  FemsApiFemsHourlyGetRequest,
  FemsApiFemsHourlyLoadTypeGetRequest,
  FemsApiFemsMonthlyGetRequest,
  FemsApiFemsMonthlyLoadTypeGetRequest,
  FemsApiFemsPeriodGetRequest,
  FemsApiFemsPeriodLoadTypeGetRequest,
  FemsApiFemsQuarterHourlyGetRequest,
  FemsApiFemsUsageAgainstTargetGetRequest,
} from "@sizlcorp/sizl-api-document/dist/models";

// 실시간 에너지 소비 금액 현황
export const timeAndLoadTypes = createQueryKeys("timeAndLoadTypes", {
  all: null,
  // 시간대 별
  getTimeHourly: (params: FemsApiFemsHourlyGetRequest) => {
    return {
      queryKey: ["femsHourlyGet", params],
      queryFn: () => EmsInstance.femsHourlyGet(params),
    };
  },
  // 일별
  getTimeDaily: (params: FemsApiFemsDailyGetRequest) => {
    return {
      queryKey: ["femsDailyGet", params],
      queryFn: () => EmsInstance.femsDailyGet(params),
    };
  },
  // 월별
  getTimeMonthly: (params: FemsApiFemsMonthlyGetRequest) => {
    return {
      queryKey: ["femsMonthlyGet", params],
      queryFn: () => EmsInstance.femsMonthlyGet(params),
    };
  },
  // 시간+부하별
  getTimeHourlyLoadType: (params: FemsApiFemsHourlyLoadTypeGetRequest) => {
    return {
      queryKey: ["femsHourlyLoadTypeGet", params],
      queryFn: () => EmsInstance.femsHourlyLoadTypeGet(params),
    };
  },
  // 일+부하별
  getTimeDailyLoadType: (params: FemsApiFemsDailyLoadTypeGetRequest) => {
    return {
      queryKey: ["femsDailyLoadTypeGet", params],
      queryFn: () => EmsInstance.femsDailyLoadTypeGet(params),
    };
  },
  // 월+부하별
  getTimeMonthlyLoadType: (params: FemsApiFemsMonthlyLoadTypeGetRequest) => {
    return {
      queryKey: ["femsMonthlyLoadTypeGet", params],
      queryFn: () => EmsInstance.femsMonthlyLoadTypeGet(params),
    };
  },
  // 기간
  getPeriod: (params: FemsApiFemsPeriodGetRequest) => {
    return {
      queryKey: ["femsPeriodGet", params],
      queryFn: () => EmsInstance.femsPeriodGet(params),
    };
  },
  // 기간+부하별
  getPeriodLoadType: (params: FemsApiFemsPeriodLoadTypeGetRequest) => {
    return {
      queryKey: ["femsPeriodLoadTypeGet", params],
      queryFn: () => EmsInstance.femsPeriodLoadTypeGet(params),
    };
  },
  // 15분별
  getQuarterHourly: (params: FemsApiFemsQuarterHourlyGetRequest) => {
    return {
      queryKey: ["femsQuarterHourlyGet", params],
      queryFn: () => EmsInstance.femsQuarterHourlyGet(params),
    };
  },
  // 현재 부하
  getCurrentLoadType: (params) => {
    return {
      queryKey: ["femsCurrentLoadTypeGet", params],
      queryFn: () => EmsInstance.femsCurrentLoadTypeGet(params),
    };
  },

  // 목표 대비 실적
  usageAgaunstTarget: (params: FemsApiFemsUsageAgainstTargetGetRequest) => {
    return {
      queryKey: ["femsUsageAgaunstTargetGet", params],
      queryFn: () => EmsInstance.femsUsageAgainstTargetGet(params),
    };
  },

  // 기계타입별 데이터
  getEquipment: (params: FemsApiFemsDailyWithEquipmentTypeGetRequest) => {
    return {
      queryKey: ["femsEquipmentGet", params],
      queryFn: () => EmsInstance.femsDailyWithEquipmentTypeGet(params),
    };
  },

  // 월별 청구요금
  getMonthlyBilling: (params: FemsApiFemsBillingGetRequest) => {
    return {
      queryKey: ["femsMonthlyBillingGet", params],
      queryFn: () => EmsInstance.femsBillingGet(params),
    };
  },
});

export const MonitoringQueryKeys = mergeQueryKeys(timeAndLoadTypes);
